/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import { notification, message } from 'antd';
import { getLang } from '../../../config/helpers';
import { auth } from '../../../firebase';
import * as AuthAPI from '../../../api/auth';
import { deleteImage } from '../../../api/images';
import { deleteDocument, addListDocuments } from '../../../api/documents';
import { setAppIsLoading, setContentIsLoading } from '../loading';
import TEXTS from './_texts/index.texts';

const lang = getLang();

export const SET_USER = 'SET_USER';
export const SET_EVENT = 'SET_EVENT';
export const SET_DOCS = 'SET_DOCS';
export const SET_REMOVE_DOC = 'SET_REMOVE_DOC';

export const setUser = value => ({
    type: SET_USER,
    payload: value,
});

export const setDocs = value => ({
    type: SET_DOCS,
    payload: value,
});
export const setRemoveDoc = value => ({
    type: SET_REMOVE_DOC,
    payload: value,
});

export const setEVENT = value => ({
    type: SET_EVENT,
    payload: value,
});


export const sessionExpired = async (err, dispatch) => {
    const errMsg = TEXTS[err.code];
    if (errMsg) {
        notification.error({
            message: TEXTS.errorNotificationMessage[lang],
            description: errMsg[lang],
        });
        await auth.signOut();
        await AuthAPI.logout();
        dispatch(setUser(null));
    } else if (err.response && err.response.data) {
        if (err.response.data.code === 'auth/argument-error') {
            await auth.signOut();
            await AuthAPI.logout();
            dispatch(setUser(null));
        }
    }
};


const tooManyRequestsFbError = (err) => {
    if (err.response) {
        if (err.response.data) {
            if (err.response.data.code === 'auth/internal-error') {
                notification.error({
                    message: TEXTS.errorNotificationMessage[lang],
                    description: TEXTS['auth/too-many-requests'][lang],
                });
            }
        }
    }
};

export const checkAuthAsync = fromUnconfirmed => async (dispatch) => {
    dispatch(setAppIsLoading(true));
    try {
        const authStatus = await AuthAPI.getStatus();
        if (authStatus.user) dispatch(setUser(authStatus.user));
        if (fromUnconfirmed) {
            if (!authStatus.user.email_verified) message.warning(TEXTS.emailStillUnconfirmed[lang]);
        }
    } catch (err) {
        sessionExpired(err, dispatch);
    }
    dispatch(setAppIsLoading(false));
};


export const recoverPassword = async (email) => {
    try {
        await AuthAPI.resetPasswordPatient(email);
        notification.success({
            message: TEXTS.notifEmailVerificationSuccessMessage[lang],
            description: TEXTS.notifPasswordResetSuccessDescription[lang],
        });
    } catch (err) {
        tooManyRequestsFbError(err);
        sessionExpired(err);
    }
};


export const sendEmailVerification = async () => {
    try {
        await AuthAPI.generatEmailVerification();
        notification.success({
            message: TEXTS.notifEmailVerificationSuccessMessage[lang],
            description: TEXTS.notifEmailVerificationSuccessDescription[lang],
        });
    } catch (err) {
        tooManyRequestsFbError(err);
        sessionExpired(err);
    }
};
export const updateUserEmail = email => async (dispatch) => {
    try {
        const res = await AuthAPI.updateMail(email);
        dispatch(setUser(res.data));
        message.success(TEXTS.updateEmailSuccess[lang]);
    } catch (err) {
        tooManyRequestsFbError(err);
        sessionExpired(err, dispatch);
    }
};

export const signUpAsync = credentials => async (dispatch) => {
    try {
        dispatch(setAppIsLoading(true));
        try {
            const res = await auth.createUserWithEmailAndPassword(
                credentials.email,
                credentials.password,
            );
            if (res.user) {
                const token = await res.user.getIdToken();
                // res.user.sendEmailVerification();
                credentials._id = res.user.uid;
                credentials.token = token;
                delete credentials.password;
                const response = await AuthAPI.register(credentials);
                dispatch(setUser(response.data));
            }
        } catch (err) {
            sessionExpired(err, dispatch);
        }
        dispatch(setAppIsLoading(false));
    } catch (err) {
        sessionExpired(err, dispatch);
    }
};

export const loginAsync = credentials => async (dispatch) => {
    dispatch(setAppIsLoading(true));
    try {
        try {
            const res = await auth.signInWithEmailAndPassword(
                credentials.email,
                credentials.password,
            );
            if (res.user) {
                const idToken = await res.user.getIdToken(true);
                const id = res.user.uid;
                const response = await AuthAPI.login({ idToken, id });
                const AuthenticatedUser = response.data;
                localStorage.setItem('disconnected', false);
                dispatch(setUser(AuthenticatedUser));
            }
        } catch (err) {
            sessionExpired(err, dispatch);
        }
    } catch (err) {
        sessionExpired(err, dispatch);
    }
    dispatch(setAppIsLoading(false));
    return null;
};

export const disconnectAsync = () => async (dispatch) => {
    dispatch(setAppIsLoading(true));
    try {
        await auth.signOut();
        await AuthAPI.logout();
        dispatch(setUser(null));
        message.success(TEXTS.sucessDisconnect[lang]);
    } catch (err) {
        sessionExpired(err, dispatch);
    }
    dispatch(setAppIsLoading(false));
};


export const updateUserAsync = body => async (dispatch) => {
    dispatch(setContentIsLoading(true));
    try {
        const res = await AuthAPI.update(body);
        if (res.data) {
            dispatch(setUser(res.data));
        }
    } catch (err) {
        sessionExpired(err, dispatch);
    }
    dispatch(setContentIsLoading(false));
};


export const setStripeCustomerAsync = body => async (dispatch) => {
    try {
        const res = await AuthAPI.setStripeCustomer(body);
        if (res.data) {
            dispatch(setUser(res.data));
        }
    } catch (err) {
        sessionExpired(err, dispatch);
    }
};

export const deleteImageAsync = (userId, filename) => async (dispatch) => {
    try {
        const res = await deleteImage(userId, filename);
        if (res.data) {
            dispatch(setUser(res.data));
        }
    } catch (err) {
        sessionExpired(err, dispatch);
    }
};

export const deleteDocumentAsync = docId => async (dispatch) => {
    try {
        if (docId) {
            dispatch(setRemoveDoc(docId));
        }
    } catch (err) {
        sessionExpired(err, dispatch);
    }
};


export const grantPermissionAsync = doctorId => async (dispatch) => {
    try {
        const res = await AuthAPI.grantPermission(doctorId);
        if (res.data) {
            dispatch(setUser({ ...res.data, email_verified: true }));
        }
    } catch (err) {
        sessionExpired(err, dispatch);
    }
};


export const revokePermissionAsync = doctorId => async (dispatch) => {
    try {
        const res = await AuthAPI.revokePermission(doctorId);
        if (res.data) {
            dispatch(setUser(res.data));
        }
    } catch (err) {
        sessionExpired(err, dispatch);
    }
};

export const addDocumentAsync = data => async (dispatch) => {
    try {
        if (data) {
            dispatch(setDocs(data));
        }
    } catch (err) {
        sessionExpired(err, dispatch);
    }
};
